import React from "react";
import { makeStyles } from "@material-ui/core";
import LoadingIcon from "@View/components/svgComponents/LoadingIcon";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((_theme) => ({
  loading: {
    padding: "25px 0",
    textAlign: "center",
    color: "rgba(84, 96, 111, 1)",
    fontSize: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  iconWrap: {
    position: "relative",
    display: "inline-block",
  },
  percent: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16, // уменьшен размер шрифта
    fontWeight: 700,
    color: "#2196f3",
    pointerEvents: "none",
    userSelect: "none",
  },
  status: {
    color: "#54606F",
    fontSize: "15px",
    marginTop: "10px",
  },
}));

const CommonProgressLoader = ({ progress = 0, status = "" }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.loading}>
      <div className={classes.iconWrap}>        
        <LoadingIcon />
        <span className={classes.percent}>{Math.round(progress)}%</span>
      </div>
      <div className={classes.status}>{status}</div>
    </div>
  );
};

export default CommonProgressLoader;
